"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDepositEstimate = exports.DefaultWithdrawEstimate = exports.InvalidNonceRetryDelay = exports.MaxInvalidNonceAttempts = exports.WalletStatusFetcherDelay = exports.WalletStatusFetcherTimeout = void 0;
exports.WalletStatusFetcherTimeout = 60000;
// too low delay may not give enough time to some vms to produce the transaction
// and/or the utxos after the transaction is accepted
exports.WalletStatusFetcherDelay = 100;
exports.MaxInvalidNonceAttempts = 5;
exports.InvalidNonceRetryDelay = 1000;
exports.DefaultWithdrawEstimate = BigInt(100000);
exports.DefaultDepositEstimate = BigInt(100000);
